import useConnectWallet from "@/store/wallet/useConnectWallet";
import { useCallback, useEffect, useState } from "react";

/**
 * useGetDayTeamStake - 获取当日团队新增质押量
 */
const useGetDayTeamStake = () => {
    const { address, contractEvm: { QueryFunction, FlexibleStaking } } = useConnectWallet();

    // 当日新增业绩
    const [dayTeamStake, setDayTeamStake] = useState<bigint>(BigInt(0));
    // loading
    const [dayTeamStakeLod, setLoading] = useState(false);

    /**
     * getDayTeamStake - 获取某天某个用户的直推业绩
     * 该值会根据提取情况和质押情况来减少和增加
     */
    const getDayTeamStake = useCallback(async () => {
        if (!QueryFunction || !FlexibleStaking || !address) return;

        try {
            setLoading(true);

            // 获取当前天数
            const day = await FlexibleStaking.getCurDay();
            // 获取该天的团队质押量
            const res = await QueryFunction.dayUserTeamStake(day, address);
            setDayTeamStake(res);

        } catch (error) {
            console.log('useGetDayTeamStake error:', error);
        } finally {
            setLoading(false);
        }
    }, [FlexibleStaking, QueryFunction, address]);

    useEffect(() => {
        getDayTeamStake();
    }, [getDayTeamStake]);

    return {
        dayTeamStake,
        dayTeamStakeLod,
        getDayTeamStake
    };
};

export default useGetDayTeamStake;
